module.exports = __webpack_public_path__ + "img/Splashscreen_global2.e76b5c6d.jpg";